import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export interface SummaryChartData {
  hseData:    number[];
  hseScore:   number;
  ltiData:    number[];
  ltiScore:   number | null;
  creData:    number[];
  creScore:   number;
  summaryRow?: {
    region:   string;
    hseIp:    number | null;
    lti:      number | null;
    cre:      number | null;
    cis:      number | null;
    cisTrend: 'up' | 'down' | 'flat';
  };
  recentLtis?:      string[];
  overdueFindings?: Array<{ date: string; location: string; level: number; dateColor: string; findingNumber?: string }>;
  creTableData?:    any[];
  aiText?:          string;
}

@Injectable({ providedIn: "root" })
export class SummaryModalService {
  isOpen$ = new BehaviorSubject<boolean>(false);
  chartData$ = new BehaviorSubject<SummaryChartData | null>(null);

  setChartData(data: SummaryChartData): void {
    this.chartData$.next(data);
  }

  open(): void {
    this.isOpen$.next(true);
    // Lock Ionic ion-content scroll
    const ionContent = document.querySelector("ion-content.dashboard-wrapper") as HTMLElement;
    if (ionContent) {
      ionContent.style.setProperty("--overflow", "hidden");
    }
  }

  close(): void {
    this.isOpen$.next(false);
    // Restore Ionic ion-content scroll
    const ionContent = document.querySelector("ion-content.dashboard-wrapper") as HTMLElement;
    if (ionContent) {
      ionContent.style.removeProperty("--overflow");
    }
  }
}
